//Component that renders a table or form to change all prices at once.

//PriceListTableAll component

import React, { useState } from "react";
import AddLocationFormButton from "../AddLocationFormButton";
import "./styles.css";
import { Menu, Spin } from "antd";

import axios from "axios";
import {
  Table,
  Input,
  InputNumber,
  Button,
  Tag,
  Popconfirm,
  Form,
  Typography,
} from "antd";
import MenuItem from "antd/lib/menu/MenuItem";

const config = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
};

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

//PriceListTable component
const PriceListTableAll = (props) => {
  const [form] = Form.useForm();

  const [data, setData] = useState(props.prices); //Data

  console.log(`data/prices: `, props.prices);
  console.log(`editedprices: `, props.editedPrices);

  const [editingid, setEditingid] = useState("");
  const datas = [...props.prices];

  console.log(`editingId, ${editingid}`);

  console.log("Status", props.status);

  const isEditing = (record) => {
    // console.log(`record inside isEditing`, record);
    return record.Id === editingid;
  };

  const edit = (record) => {
    console.log("edit, record", record);
    console.log("form", form);
    form.setFieldsValue({
      // name: "",
      // server: "",
      // database: "",
      // username: "",
      // password: "",
      // status: "",
      Name: "",
      Price: "",
      ...record,
    });
    setEditingid(record.Id);
  };

  const cancel = () => {
    setEditingid("");
  };

  const save = async (id) => {
    const editFields = await form.validateFields();
    const newData = { id, ...editFields };

    console.log("newData", newData);
    axios
      .post("/api/data/123", newData, config)
      .then((response) => {
        setEditingid("");
        props.rerender();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleInputChange = (newPrice, MenuItemPortionId, Name, OldPrice) => {
    props.setEditedPrices(
      props.editedPrices.map((element) => {
        return element.MenuItemPortionId === MenuItemPortionId
          ? { ...element, Price: parseInt(newPrice) }
          : { ...element };
      })
    );
  };

  const filterMenu = async () => {
    const filteredMenu = await props.editedPrices.filter((e, i) => {
      return e.Price !== props.prices[i].Price;
    });

    console.log(`Filtered Menu: ${filteredMenu}`);
    console.log(filteredMenu);

    axios
      .post("/api/data/changeme", filteredMenu, config)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "Id",
      width: "4%",
      editable: false,
    },
    {
      title: "MenuItemPortionId",
      dataIndex: "MenuItemPortionId",
      width: "4%",
      editable: false,
    },
    {
      title: "Categoria",
      dataIndex: "GroupCode",
      width: "5%",
      editable: false,
    },
    {
      title: "Nombre",
      dataIndex: "Name",
      width: "10%",
      editable: true,
    },
    {
      title: "Precio",
      dataIndex: "Price",
      width: "5%",
      editable: true,
    },
    {
      title: "All",
      dataIndex: "All",
      width: "25%",
      editable: true,
      render: (_, record) => {
        // Para cambiar precios, utilizar MenuItemPortionId como Id 08.07.2024
        const { Id, Name, PortionId, Price } = record;

        return (
          <Input
            onChange={(e) => {
              handleInputChange(e.target.value, PortionId, Name, Price);
            }}
            defaultValue={Price}
          ></Input>
        );
      },
    },
    {
      title: "Opciones",
      dataIndex: "operation",
      width: "5%",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.Id)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <div className="actions">
            <Typography.Link
              disabled={editingid !== ""}
              onClick={() => edit(record)}
            >
              Edit
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={(e) => {
                handleDelete(record);
              }}
            >
              <a>Delete</a>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const handleDelete = (record) => {
    let data = { id: record._id };

    console.log(data);

    axios
      .delete("/api/data/delete123", {
        headers: { "Content-Type": "application/json" },
        data: data,
        withCredentials: true,
      })
      .then((response) => {
        props.rerender();
      })
      .catch((error) => {
        console.log(error);
      });

    // axios.delete("/api/data/removecon", {
    //   headers: { "Content-Type": "application/json" },
    //   data: { id: 123 },
    //   withCredentials: true,
    // });
  };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "Id" ? "name" : "server" && "status",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <>
      <div className="buttons-layout">
        <AddLocationFormButton
          // rerender={props.rerender}
          data={data}
          setData={setData}
          // addLocation={props.addLocation}
          // setAddLocation={props.setAddLocation}
        />
        <Button
          type="primary"
          style={{ backgroundColor: "green", borderColor: "green" }}
          onClick={filterMenu}
        >
          CAMBIAR PRECIOS
        </Button>
      </div>

      <Form form={form} component={false}>
        <Table
          size="small"
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          bordered
          dataSource={datas}
          columns={mergedColumns}
          rowClassName="editable-row"
          rowKey="MenuItemPortionId"
          // pagination={{
          //   onChange: cancel,
          // }}
          pagination={false}
        />
      </Form>
    </>
  );
};

export default PriceListTableAll;
